interface CookieOptions {
  days?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  expires?: string;
}

const cookie = {
  set: function (name: string, value: string, options: CookieOptions = {}): void {
    if (!name) {
      throw new Error('Cookie name is required.');
    }
    if (value === undefined || value === null) {
      value = '';
    }

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(String(value))}`;

    if (options.days !== undefined) {
      const date = new Date();
      date.setTime(date.getTime() + options.days * 24 * 60 * 60 * 1000);
      cookieString += `; expires=${date.toUTCString()}`;
    }

    if (options.path) {
      cookieString += `; path=${options.path}`;
    } else {
      cookieString += '; path=/'; // Default path
    }

    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }

    if (options.secure) {
      cookieString += '; secure';
    }

    if (options.sameSite) {
      cookieString += `; samesite=${options.sameSite}`;
    }

    document.cookie = cookieString;
  },

  get: function (name: string): string | null {
    if (!name) {
      throw new Error('Cookie name is required.');
    }
    const nameEQ = `${encodeURIComponent(name)}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },

  update: function (name: string, value: string, options: CookieOptions = {}): void {
    if (!name) {
      throw new Error('Cookie name is required.');
    }
    this.set(name, value, options);
  },

  remove: function (name: string, options: CookieOptions = {}): void {
    if (!name) {
      throw new Error('Cookie name is required.');
    }
    // To delete a cookie, set its expiration date to a past time
    const pastDate = new Date(0);
    this.set(name, '', {
      ...options,
      days: undefined,
      expires: pastDate.toUTCString(),
    });
  },

  exists: function (name: string): boolean {
    return this.get(name) !== null;
  },
};

export default cookie;
